import React, { forwardRef, InputHTMLAttributes } from 'react';

import { cn } from 'src/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Checkbox = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        type='checkbox'
        className={cn(
          'h-4 w-4 rounded border-border-default bg-layout text-primary-default focus:outline-none focus:ring-2 focus:ring-primary-focus focus:ring-offset-2 focus:ring-offset-layout disabled:pointer-events-none disabled:border-border-default disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Checkbox.displayName = 'Input';

export { Checkbox };
